import { render, staticRenderFns, recyclableRender, components } from "./change-address.vue?vue&type=template&id=6dd5b6c9&scoped=true&"
var renderjs
import script from "./change-address.vue?vue&type=script&lang=js&"
export * from "./change-address.vue?vue&type=script&lang=js&"
import style0 from "./change-address.vue?vue&type=style&index=0&id=6dd5b6c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5b6c9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/setting/change-address.vue"
export default component.exports